import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';

function round(date, method = 'ceil', duration = moment.duration(15, 'minutes')) { // see https://stackoverflow.com/a/39637877
  return moment(Math[method]((+date) / (+duration)) * (+duration));
}

class DateRangeSelect extends Component {
  constructor(props) {
    super(props);
    const ranges = {
      Today: [
        moment().startOf('day'),
        round(moment()),
      ],
      Yesterday: [
        moment().subtract(1, 'days').startOf('day'),
        round(moment().subtract(1, 'days').endOf('day'), 'floor'),
      ],
      'Last 7 Days': [
        moment().subtract(6, 'days').startOf('day'),
        round(moment(), 'ceil'),
      ],
      'Last 30 Days': [
        moment().subtract(29, 'days').startOf('day'),
        round(moment(), 'ceil'),
      ],
      'This Month': [
        moment().startOf('month'),
        round(moment().endOf('month'), 'floor'),
      ],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        round(moment().subtract(1, 'month').endOf('month'), 'floor'),
      ],
    };

    const initial = {
      startDate: props.startDate || _.get(ranges, `${props.initialRange}.0`),
      endDate: props.endDate || _.get(ranges, `${props.initialRange}.1`),
    };

    this.state = {
      ranges,
      startDate: initial.startDate ? moment(initial.startDate) : null,
      endDate: initial.endDate ? moment(initial.endDate) : null,
    };
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({
      startDate: props.startDate ? moment(props.startDate) : null,
      endDate: props.endDate ? moment(props.endDate) : null,
    });
  }

  onChange(startDate, endDate) {
    this.setState({ startDate, endDate });
    this.props.onChange({ startDate, endDate });
  }

  render() {
    const { startDate, endDate, ranges } = this.state;
    const { timePicker } = this.props;
    const hasValue = (startDate && endDate);
    let label = this.props.placeholder;
    if (hasValue) {
      const fmtStart = startDate.format('DD/MM/YY');
      const fmtEnd = endDate.format('DD/MM/YY');
      label = (fmtStart === fmtEnd ? fmtStart : `${fmtStart} → ${fmtEnd}`);
    }

    return (
      <DateRangePicker
        startDate={startDate || moment()}
        endDate={endDate || moment()}
        ranges={ranges}
        style={{ minWidth: 'unset' }}
        locale={{ format: 'DD/MM/YYYY', cancelLabel: 'Clear' }}
        onApply={(e, { startDate: start, endDate: end }) => this.onChange(start, end)}
        onCancel={() => this.onChange(null, null)}
        autoUpdateInput={false}
        alwaysShowCalendars
        timePicker={timePicker}
        timePicker24Hour
        timePickerIncrement={15}
      >
        <Button color={hasValue ? 'danger' : 'primary'} outline>
          {!hasValue && <FA icon={faCalendarAlt} style={{ marginRight: '5px' }} />}
          {label}
        </Button>
      </DateRangePicker>
    );
  }
}

DateRangeSelect.propTypes = {
  placeholder: PropTypes.string,
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  initialRange: PropTypes.string,
  timePicker: PropTypes.bool,
};

DateRangeSelect.defaultProps = {
  placeholder: 'Select Date Range',
  startDate: null,
  endDate: null,
  initialRange: null,
  onChange: () => { },
  timePicker: false,
};

export default DateRangeSelect;



// WEBPACK FOOTER //
// ./src/client/components/common/DateRangeSelect.js